const controls = document.querySelector('.page-list-controls');
if (controls) {
    const list     = document.querySelector('.page-list__items');
    const filterEl = controls.querySelector('[data-filter="category"]');
    const sortEl   = controls.querySelector('[data-sort]');

    // Resize a select to fit its selected option text
    const sizer = document.createElement('span');
    sizer.style.cssText = 'position:absolute;visibility:hidden;white-space:pre;pointer-events:none';
    document.body.appendChild(sizer);

    function resizeSelect(el) {
        const selected = el.options[el.selectedIndex];
        if (!selected) return;
        const style = getComputedStyle(el);
        sizer.style.font = style.font;
        sizer.textContent = selected.text;
        el.style.width = (sizer.offsetWidth + 32) + 'px'; // 32px for arrow padding
    }

    function updateArrow(el) {
        const arrow = el.parentElement.querySelector('.page-list-controls__arrow');
        if (!arrow) return;
        // Active if a real value is selected (not empty, not the disabled placeholder)
        arrow.classList.toggle('active', el.value !== '');
    }

    function resizeAll() {
        if (filterEl) resizeSelect(filterEl);
        if (sortEl)   resizeSelect(sortEl);
    }

    function updateArrows() {
        if (filterEl) updateArrow(filterEl);
        if (sortEl)   updateArrow(sortEl);
    }

    if (!list) { resizeAll(); return; }

    if (!list) return;

    // Cache original DOM order
    const getCards = () => [...list.querySelectorAll('.page-card')];

    function apply() {
        const filterVal = filterEl?.value ?? '';
        const sortVal   = sortEl?.value   ?? 'title-asc';

        let cards = getCards();

        // Filter
        cards.forEach(card => {
            const cats = (card.dataset.categories ?? '').split(',').map(s => s.trim());
            const show = !filterVal || cats.includes(filterVal);
            card.hidden = !show;
        });

        // Sort
        const visible = cards.filter(c => !c.hidden);
        const [key, dir] = sortVal.split('-');
        const mult = dir === 'desc' ? -1 : 1;

        visible.sort((a, b) => {
            const av = (a.dataset[key] ?? '').toLowerCase();
            const bv = (b.dataset[key] ?? '').toLowerCase();
            return av.localeCompare(bv) * mult;
        });

        visible.forEach(card => list.appendChild(card));
    }

    filterEl?.addEventListener('change', () => { apply(); resizeSelect(filterEl); updateArrow(filterEl); });
    sortEl?.addEventListener('change',   () => { apply(); resizeSelect(sortEl);   updateArrow(sortEl); });

    resizeAll();
    updateArrows();
}
